import { DataStub } from '@tencent/data-schema-core';
const humanNames = 'James,John,Robert,Michael,William,David,Richard,Joseph,Thomas,Charles,Christopher,Daniel,Matthew,Anthony,Donald,Mark,Paul,Steven,Andrew,Kenneth,Joshua,Kevin,Brian,George,Edward,Ronald,Timothy,Jason,Jeffrey,Ryan,Jacob,Gary,Nicholas,Eric,Jonathan,Stephen,Larry,Justin,Scott,Brandon,Benjamin,Samuel,Frank,Gregory,Raymond,Alexander,Patrick,Jack,Dennis,Jerry,Tyler,Aaron,Jose,Henry,Adam,Douglas,Nathan,Peter,Zachary,Kyle,Walter,Harold,Jeremy,Ethan,Carl,Keith,Roger,Gerald,Christian,Terry,Sean,Arthur,Austin,Noah,Lawrence,Jesse,Joe,Bryan,Billy,Jordan,Albert,Dylan,Bruce,Willie,Gabriel,Alan,Juan,Logan,Wayne,Ralph,Roy,Eugene,Randy,Vincent,Russell,Louis,Philip,Bobby,Johnny,Bradley,Mary,Patricia,Jennifer,Linda,Elizabeth,Barbara,Susan,Jessica,Sarah,Karen,Nancy,Lisa,Margaret,Betty,Sandra,Ashley,Dorothy,Kimberly,Emily,Donna,Michelle,Carol,Amanda,Melissa,Deborah,Stephanie,Rebecca,Laura,Sharon,Cynthia,Kathleen,Amy,Shirley,Angela,Helen,Anna,Brenda,Pamela,Nicole,Samantha,Katherine,Emma,Ruth,Christine,Catherine,Debra,Rachel,Carolyn,Janet,Virginia,Maria,Heather,Diane,Julie,Joyce,Victoria,Kelly,Christina,Lauren,Joan,Evelyn,Olivia,Judith,Megan,Cheryl,Martha,Andrea,Frances,Hannah,Jacqueline,Ann,Gloria,Jean,Kathryn,Alice,Teresa,Sara,Janice,Doris,Madison,Julia,Grace,Judy,Abigail,Marie,Denise,Beverly,Amber,Theresa,Marilyn,Danielle,Diana,Brittany,Natalie,Sophia,Rose,Isabella,Alexis,Kayla,Charlotte'.split(',');
const randint = max => Math.round(Math.random() * max);
const randpick = arr => arr[randint(arr.length - 1)];

/**
 * 从一个 dataSchema 生成一个 mock 数据
 * @param {any} dataSchema
 */
export function makeMockData(dataSchema) {
  const rootStub = new DataStub({
    schema: dataSchema
  });
  rootStub.value = rootStub.getDefaultValue({
    optionalProperties: 'always'
  });

  /** @type {DataStub[]} */
  const stubsToCheck = [rootStub];
  while (stubsToCheck.length) {
    const stub = stubsToCheck.shift();

    // 如果有强制默认值、枚举，就不用多此一举生成mock
    // eslint-disable-next-line eqeqeq
    if (stub.schema.default != null || stub.schema.enum) continue;
    switch (stub.type) {
      case 'string':
        // 是字符串的话，随便塞入点东西
        stub.value = `${randpick(humanNames)}${randpick(humanNames)}`;
        break;
      case 'number':
      case 'integer':
        // 是数字的话，给个随机数
        stub.value = randint(100);
        break;
      case 'object':
        // 是对象的话，把它的全部field抽出来，稍后做检查
        stub.getFields().fields.forEach(f => {
          if (f.id) stubsToCheck.push(stub.getChildStub(f.id));
        });
        break;
      case 'array':
        // 是数组的话，此时默认值是空数组，需要填充点东西
        {
          const arr = Array.from({
            length: 3
          }, () => ({}));
          stub.value = arr;
          arr.map((_, i) => stub.getChildStub(i)).forEach(childStub => {
            // eslint-disable-next-line no-param-reassign
            childStub.value = childStub.getDefaultValue({
              optionalProperties: 'always'
            });
            stubsToCheck.push(childStub);
          });
        }
        break;
    }
  }
  return rootStub.value;
}